export function strReplace(value: string, search: string, replace: string | number): string {
    return value.split(search).join(replace.toString());
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/str_replace.function.ts